import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ListItem from './ListItem';
import List from './List';
import Button from './Button';
import { Typography } from '@material-ui/core';

var styles = function styles(theme) {
  return {
    overflow: {
      overflowY: 'scroll'
    }
  };
};

var DynamicList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DynamicList, _React$Component);

  function DynamicList() {
    var _getPrototypeOf2;

    var _this2;

    _classCallCheck(this, DynamicList);

    var _temp, _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this2, (_temp = _this = _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DynamicList)).call.apply(_getPrototypeOf2, [this].concat(args))), _this2.state = {
      offset: 0,
      total: 0,
      data: [],
      limit: 10,
      updating: true,
      sort: undefined,
      text: undefined
    }, _this2.clearAndLoad = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                offset: 0,
                data: [],
                total: 0,
                limit: 10,
                updating: true,
                sort: undefined,
                text: undefined
              }, _this.load);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this2.checkIsIn = function (docs, id) {
      var isIn = false;
      docs.forEach(function (element) {
        if (element.id === id) {
          isIn = true;
        }
      });
      return isIn;
    }, _this2.load = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _this$props, provider, onLoad, filters, selected, _this$state, offset, limit, sort, text, data, id, isIn, pageNow, others, _ref3, docs, other, _ref4, _docs, _other;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, provider = _this$props.provider, onLoad = _this$props.onLoad, filters = _this$props.filters, selected = _this$props.selected;
              _this$state = _this.state, offset = _this$state.offset, limit = _this$state.limit, sort = _this$state.sort, text = _this$state.text;
              data = _toConsumableArray(_this.state.data && _this.state.data || []);
              id = selected ? selected.id : null;
              isIn = false;
              pageNow = offset / limit;
              others = {};

              _this.setState({
                updating: true
              });

              if (!(data.length !== 0)) {
                _context2.next = 18;
                break;
              }

              _context2.next = 11;
              return provider(limit * pageNow, limit, sort, text, filters);

            case 11:
              _ref3 = _context2.sent;
              docs = _ref3.docs;
              other = _objectWithoutProperties(_ref3, ['docs']);
              others = other;
              data = [].concat(_toConsumableArray(data), _toConsumableArray(docs));
              _context2.next = 28;
              break;

            case 18:
              _context2.next = 20;
              return provider(limit * pageNow, limit, sort, text, filters);

            case 20:
              _ref4 = _context2.sent;
              _docs = _ref4.docs;
              _other = _objectWithoutProperties(_ref4, ['docs']);
              pageNow += 1;
              others = _other;

              if (id !== null) {
                isIn = _this.checkIsIn(_docs, id);
              }

              data = [].concat(_toConsumableArray(data), _toConsumableArray(_docs));

            case 27:
              if (id !== null && !isIn && others.total > limit * pageNow) {
                _context2.next = 18;
                break;
              }

            case 28:
              _this.setState({
                data: data,
                offset: others.offset + others.limit,
                limit: others.limit,
                total: others.total,
                updating: false
              });

              onLoad && onLoad({
                data: data,
                offset: others.offset + others.limit,
                limit: others.limit,
                total: others.total
              });

            case 30:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), _temp));
  }

  _createClass(DynamicList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var oldFilters = prevProps.filters;
      var newFilters = this.props.filters;

      if (JSON.stringify(oldFilters) !== JSON.stringify(newFilters)) {
        this.clearAndLoad();
      }

      if (this.props.scroll) {
        this.props.scroll();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          renderer = _this$props2.renderer,
          subheaderBy = _this$props2.subheaderBy,
          subheaderRenderer = _this$props2.subheaderRenderer,
          noDataMessage = _this$props2.noDataMessage;
      var _this$state2 = this.state,
          data = _this$state2.data,
          offset = _this$state2.offset,
          total = _this$state2.total,
          updating = _this$state2.updating;
      var loadMore = !(total === 0) && total && total > offset;
      var flag;
      return React.createElement(List, null, data && data.map(function (item, idx) {
        if (subheaderBy && subheaderRenderer) {
          if (subheaderBy(item) === flag) {
            flag = subheaderBy(item);
            return renderer(item, idx);
          }

          flag = subheaderBy(item);
          return React.createElement(React.Fragment, {
            key: 'fragment-' + idx
          }, subheaderRenderer(item), renderer(item, idx));
        } else {
          return renderer(item);
        }
      }), (!data || data.length === 0) && !updating && React.createElement(React.Fragment, null, noDataMessage, !noDataMessage && React.createElement(Typography, null, 'No data')), updating && React.createElement(ListItem, null, 'Updating...'), !updating && loadMore && React.createElement(ListItem, {
        onClick: this.load,
        style: {
          padding: 0,
          marginTop: '5px'
        }
      }, React.createElement(Button, {
        style: {
          width: '100%'
        },
        color: 'secondary',
        variant: 'outlined'
      }, 'Load More')));
    }
  }]);

  return DynamicList;
}(React.Component);

export default withStyles(styles)(DynamicList);